import _ from 'lodash';
import numeral from 'numeral';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import BuilderAx           from 'app/actions/company-admin/builder-campaign';
import RoutingAx           from 'app/actions/routing';
import Checkbox            from 'app/components/common/checkbox';
import Confirm             from 'app/components/common/confirm';
import DatePicker          from 'app/components/common/date-picker';
import Icon                from 'app/components/common/icon';
import NumberInput         from 'app/components/common/number-input';
import Link                from 'app/components/common/link';
import MatchRatioSelector  from 'app/components/common/match-ratio-selector';
import MonetaryInput       from 'app/components/common/monetary-input';
import NonprofitInput      from 'app/components/common/nonprofit-input';
import RteEditor           from 'app/components/common/rich-text/editor';
import SegmentedInput      from 'app/components/common/segmented-selector-input';
import StandardInput       from 'app/components/common/standard-input';
import StandardSelect      from 'app/components/common/standard-select';
import TimezoneInput       from 'app/components/common/timezone-input';
import Tip                 from 'app/components/common/tip';
import UploadedImageInput  from 'app/components/common/uploaded-image-input';
import BuilderDriveGood    from 'app/components/company-admin/campaigns/builder-drive-good';
import BuilderLink         from 'app/components/company-admin/common/builder-link';
import EntityInput         from 'app/components/company-admin/common/entity-input';
import Builder             from 'app/components/company-admin/layout/builder';
import BuilderFooter       from 'app/components/company-admin/layout/builder-footer';
import BuilderIterable     from 'app/components/company-admin/layout/builder-iterable';
import BuilderSection      from 'app/components/company-admin/layout/builder-section';
import BuilderSectionGroup from 'app/components/company-admin/layout/builder-section-group';
import {
  EmployeeRoles,
  DriveGoalTypes,
}                          from 'app/constants';
import format              from 'app/helpers/format';
import Ps                  from 'app/helpers/publish-statuses';
import AuthSlx             from 'app/selectors/auth';
import CadminSlx           from 'app/selectors/company-admin/';
import BuilderSlx          from 'app/selectors/company-admin/builder-campaign';
import FfSlx               from 'app/selectors/feature-flags';



import FormsDuck          from 'app/ducks/company-admin/forms';
import FieldInput from 'app/components/company-admin/forms/field-input';
import FormForm from 'app/components/company-admin/forms/builder-form-form';
import helpers from 'app/helpers/forms';


class FormBuilder extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      hasTouched: false,
      hasSubmitted: false,
    };

    this.onChangeForm = this.onChangeForm.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  get saveAttrs() {
    const {form} = this.props;
    return helpers.getFormSaveAttrs(form);
  }

  get validations() {
    const {form} = this.props;
    const v = {};
    if (!form.title) v.title = ['required'];
    if (!Object.keys(v).length) return null;
    return v;
  }

  get visibleValidations() {
    if (!this.state.hasTouched) return null;
    if (!this.state.hasSubmitted) return null;
    return this.validations;
  }

  onChangeForm(form) {
    this.setState({hasTouched: true});
    this.props.setForm(form);
  }

  onClickSave() {
    this.setState({hasSubmitted: true});
    if (this.validations) return;
    this.props.save(this.saveAttrs);
  }

  renderFooter() {
    const {savePending} = this.props;
    const btnDisabled = (() => {
      if (savePending) return true;
      if (this.visibleValidations) return true;
      if (!this.state.hasTouched) return true;
      return false;
    })();
    const btnText = (() => {
      return savePending ? 'Saving...' : 'Save';
    })();

    return (
      <BuilderFooter>
        {!!this.visibleValidations && (
          <div className="cadmin-builder-bottom-validations">
            <p>Oops! There are some required fields above that need your attention.</p>
          </div>
        )}
        <div className="cadmin-builder-bottom-actions">
          <button className="btn green" disabled={btnDisabled} onClick={this.onClickSave}>{btnText}</button>
        </div>
      </BuilderFooter>
    );
  }

  render() {
    const {form} = this.props;

    return (
      <Builder footer={this.renderFooter()} className="cadmin-camb">
        <FormForm form={form} onChange={this.onChangeForm} validations={this.visibleValidations} />
      </Builder>
    );
  }

}

FormBuilder.propTypes = {
  form: PropTypes.object.isRequired,
};

const stateToProps = (state) => ({
  currentUser: AuthSlx.currentUser(state),
  company: CadminSlx.company(state),
  savePending: FormsDuck.Slx.bldrSavePending(state),
});

const dispatchToProps = (dispatch, ownProps) => ({
  setForm: (form) => dispatch(FormsDuck.Ax.setBldrForm(form)),
  save: (attrs) => dispatch(FormsDuck.Ax.save(ownProps.form, attrs, {redirect: true})),
});

export default connect(stateToProps, dispatchToProps)(FormBuilder);
